import { Breadcrumb, Card, Image } from 'antd';
import React, { useEffect } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css'
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
// import { useParams } from 'react-router-dom';
import i18n from '../i18n';
import { CardSingle } from './utilities/CardSingle';
import { CarouselViewer } from './utilities/Carousel';

export const WheelchairCar = () => { 

  const { t } = useTranslation();
  // let { lng } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
    return (
      <React.Fragment>
        <Helmet>
            <title>InnoTrans | {t('common:wheelchaircar')}</title>
            <meta name="description" content={t('pageDescriptions:wheelchaircar')} />
            <meta name="keywords" content={t('pageKeywords:wheelchaircar')} />
            <meta httpEquiv="content-language" content={i18n.language?.substr(0,2)} />
            {/* <link rel="canonical" href={`https://innotrans.nl${lng ? `/${lng}` : ''}/wheelchaircar`} /> */}
        </Helmet>
        
         <Breadcrumb style={{ margin: '16px 0', paddingLeft: '50px' }}>
            <Breadcrumb.Item><h1>{t('common:wheelchaircar')}</h1></Breadcrumb.Item>
        </Breadcrumb>

        <CarouselViewer id='a8b24abd-dfc2-4e97-bda0-cdb96da320c1' />

        <CardSingle title={t('wheelchaircar:card1-title')}>
        <div dangerouslySetInnerHTML={{__html: t('wheelchaircar:card1-text') }} />
          <br/>
          <br/>
          <div>
            <div className='bullet-list' style={{ lineHeight: 2}}>
              <div className='bullet-item'>
                <img src={'/images/brands/mercedes.png'} alt='' className='bullet-image-larger' /> Mercedes-Benz Vito / V-klasse / <span className='text-green'>eVito</span> / <span className='text-green'>eQV</span><br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/citroen.png'} alt='' className='bullet-image-larger'/> Citroen Berlingo / Space Tourer / <span className='text-green'>e-Space Tourer</span><br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/opel.png'} alt='' className='bullet-image-larger'/> Opel Combo life / Opel Zafira en <span className='text-green'>Zafire e-life</span><br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/toyota.jpg'} alt='' className='bullet-image-larger'/> Toyota Proace City / <span className='text-green'>Toyota Proace electric</span><br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/peugeot.png'} alt='' className='bullet-image-larger'/> Peugeot Rifter / Traveller / <span className='text-green'>e-Traveller</span><br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/ford.png'} alt='' className='bullet-image-larger'/> Ford Connect<br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/vw.jpg'} alt='' className='bullet-image-larger'/> Volkswagen Caddy Maxi<br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/nissan.png'} alt='' className='bullet-image-larger' /> <span className='text-green'>Nissan e-NV 200</span><br/>
              </div>
            </div>
          </div>
        </CardSingle>

        <CardSingle title={t('wheelchaircar:card2-title')}>
          <div dangerouslySetInnerHTML={{__html: t('wheelchaircar:card2-text') }} />
        </CardSingle>

        <div className='content-flex' style={{ paddingBottom: 10 }} >
            <Card>
              <Image src='/images/wheelchaircar/floorplan-1.png' style={{ maxWidth: 150}}  preview={true} className='ant-card-cover' loading='lazy'/>
            </Card>
            <Card>
              <Image src='/images/wheelchaircar/floorplan-2.png' style={{ maxWidth: 150}}  preview={true} className='ant-card-cover' loading='lazy'/>
            </Card>
            <Card>
              <Image src='/images/wheelchaircar/floorplan-3.png' style={{ maxWidth: 150}}  preview={true} className='ant-card-cover' loading='lazy'/>
            </Card>
            <Card>
              <Image src='/images/wheelchaircar/floorplan-4.png' style={{ maxWidth: 150}}  preview={true} className='ant-card-cover' loading='lazy'/>
            </Card>
        </div>

      </React.Fragment>
    )
}